import { batchStateSchema } from '@state/_shared/batchStateSchema';
import { batchDetailsDialogStateSchema } from '@state/_shared/batchDetailsDialogStateSchema';
import { createPageTableSchema } from '@state/_shared/tableComponentStateSchema';

// Schema for individual batch rows in the table
const batchRowSchema = {
    type: 'object',
    properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        created_at: { type: 'string' },
        is_archived: { type: 'boolean' },
        status_id: { type: 'number' },
        status_name: { type: 'string' },
    },
};

const batchesTableSchema = createPageTableSchema(batchRowSchema);

export const batchesPageStateSchema = {
    // Shared batch data context (read by useBatchesTableActionHandler)
    ...batchStateSchema,

    // Dialog shown when viewing a batch's items (shared schema includes the table subtree)
    batchDetailsDialog: batchDetailsDialogStateSchema,

    // TanStack-compatible table state (pagination, sorting, selection, loading)
    table: batchesTableSchema,

    selectedBatchId: {
        type: 'string',
        default: null,
        persist: false,
        description: 'ID of the currently selected batch for viewing details',
    },

    ui: {
        type: 'object',
        properties: {
            showCreateDialog: {
                type: 'boolean',
                default: false,
                description: 'Controls visibility of the batch creation dialog',
            },
            showArchivedBatches: {
                type: 'boolean',
                default: false,
                persist: true,
                description: 'Whether to include archived batches in the display',
            },
            createForm: {
                type: 'object',
                properties: {
                    batchName: { type: 'string', default: '' },
                    error: { type: 'string', default: null },
                    isSubmitting: { type: 'boolean', default: false },
                },
            },
        },
    },
};
